import React from 'react';
import { useMediaQuery } from 'react-responsive';
import CategorySlider from '../../components/category/category-slider';
import './header-style.css';

function CategoryHeader({ category }) {
  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 736px)' });

  return (
    <React.Fragment>
      <header className={(isDesktopOrLaptop ? 'v-header' : 'h-header') + ' f-row'}>
        <div className="logo logo-right f-shrink-0 justify-content-sm-center f-basis-lg-0 f-grow-lg-1">
          <div className="d-block align-items-center align-self-center f-none justify-content-center c-p">
            <span className="logo-wrapper d-block p-relative o-hidden bs-border-box f-00auto">
              <img alt={category.title} className="logo-img" src={category.image} />
            </span>
          </div>
        </div>

        <section className="bio-section f-shrink-1 f-grow-sm-1 f-basis-sm-0 f-grow-lg-2 f-basis-lg-30p">
          <div className="bio-wrapper align-items-center f-shrink-1 f-row f-1 mb-0">
            <h1 className="title d-block o-hidden to-ellipsis w-space-nowrap">{category.title}</h1>
          </div>
        </section>
      </header>

      <CategorySlider path={'/category'} />
    </React.Fragment>
  );
}

export default CategoryHeader;
